import type React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';

export const NotFoundPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#080810',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          textAlign: 'center',
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(3rem, 8vw, 6rem)',
            color: '#ff2d95',
            fontVariantCaps: 'all-petite-caps',
            margin: 0,
          }}
        >
          404
        </h1>
        <p
          style={{
            fontSize: '1.2rem',
            color: 'rgba(255, 255, 255, 0.7)',
            fontVariantCaps: 'all-petite-caps',
            letterSpacing: 2,
            margin: '12px 0 24px',
          }}
        >
          Page Not Found / Seite nicht gefunden
        </p>
        <Link
          to="/"
          style={{
            background: '#00ff00',
            color: '#000',
            padding: '10px 24px',
            borderRadius: 24,
            textDecoration: 'none',
            fontVariantCaps: 'all-petite-caps',
            fontWeight: 700,
            letterSpacing: 1,
          }}
        >
          Return to Discography →
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
